import(/* webpackMode: "eager" */ "/var/www/tripcraftmx/frontend/src/app/[locale]/legal/privacidad/page.tsx");
